import { View } from './view'

export const Button = View
